"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = require("react-dom");
var _useMounted = _interopRequireDefault(require("../../hooks/useMounted"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Portal = function Portal(props) {
  var dom = props.dom,
    _a = props.portalWhenMounted,
    portalWhenMounted = _a === void 0 ? false : _a,
    children = props.children;
  var mounted = (0, _useMounted.default)();
  var content = (0, _react.useCallback)(function () {
    return /*#__PURE__*/(0, _reactDom.createPortal)(children, dom || document.body);
  }, [children, dom]);
  return portalWhenMounted ? mounted ? content() : null : content();
};
var _default = Portal;
exports.default = _default;